"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gotoDownload = exports.downloadTencentMeeting = exports.downloadVooVMeeting = exports.isOverseasByDomainName = exports.ELaunchAppState = void 0;
var web_base_1 = require("@tencent/web-base");
var enum_1 = require("../../enum");
/**
 * 唤起 app 的状态
 */
var ELaunchAppState;
(function (ELaunchAppState) {
    ELaunchAppState[ELaunchAppState["SUCCESS"] = 0] = "SUCCESS";
    ELaunchAppState[ELaunchAppState["FAILURE"] = 1] = "FAILURE";
    ELaunchAppState[ELaunchAppState["UNINSTALL"] = 2] = "UNINSTALL";
})(ELaunchAppState = exports.ELaunchAppState || (exports.ELaunchAppState = {}));
/**
 * 根据域名判断当前域名是在 “国内” 还是在 “国外VooV域名”
 *
 * @returns {String} is_overseas: 'yes' or 'no';
 */
var isOverseasByDomainName = function () {
    if ( // “国外VooV域名”
    window.location.origin.indexOf('voovmeeting.com') > -1) {
        return 'yes';
    }
    return 'no';
};
exports.isOverseasByDomainName = isOverseasByDomainName;
/**
 * 跳转到VooV Meeting下载链接
 *
 * 正式环境https://www.voovmeeting.com/download-center.html?from=1001
 * 测试环境https://test.web.voovmeeting.com/download-center.html?from=1001
 */
var downloadVooVMeeting = function () {
    var downloadUrl = enum_1.EnumVoovMeeting.DOWNLOAD_URL;
    if ((0, web_base_1.isTestEnv)()) {
        downloadUrl = enum_1.EnumVoovMeeting.TEST_DOWNLOAD_URL;
    }
    // beaconReport('web_invitedpage_downloadpage_downloadlink_voov_null_click', {});
    setTimeout(function () {
        window.location.href = downloadUrl;
    }, 1000);
};
exports.downloadVooVMeeting = downloadVooVMeeting;
/**
 * 下载腾讯会议app
 *
 * ----------移动端----------
 *
 * 安卓-微信：引导下载蒙层
 *
 * 安卓-非微信：跳转安卓下载页面下载
 *
 * ios-企业微信：引导下载蒙层
 *
 * ios-其他：跳转app store下载
 *
 * ----------pc端----------
 *
 * 跳转download-center下载
 *
 * @param showDefaultGuide 展示下载蒙层
 * @param launchAppState 拉起 app 状态
 * @param beaconReport 上报灯塔方法
 * @param from 上报来源
 */
var downloadTencentMeeting = function (showDefaultGuide, launchAppState, beaconReport, from) {
    if ((0, web_base_1.isMobile)()) { // 移动端下载
        var ua = navigator.userAgent;
        if ((0, web_base_1.isAndroid)()) {
            if (/mqqbrowser/i.test(ua) && /micromessenger/i.test(ua) && !(/wxwork/i.test(ua))) {
                window.history.pushState({ url: window.location.href }, document.title, "".concat(window.location.origin, "/download-android.html?from=1002"));
                // 安卓里面这个方法不太可靠
                if (launchAppState !== ELaunchAppState.SUCCESS) {
                    typeof showDefaultGuide === 'function' && showDefaultGuide();
                    // 1s 后执行回调，是为了容错
                    setTimeout(function () {
                        beaconReport === null || beaconReport === void 0 ? void 0 : beaconReport('web_launchapp_page_mask_null_null_null_explore', { fromSource: from, trigger: 'download_fail' });
                    }, 1500);
                }
            }
            else {
                location.href = "".concat(window.location.origin, "/download-android.html?from=1002");
            }
        }
        else if ((0, web_base_1.isIOS)()) {
            location.href = 'https://itunes.apple.com/cn/app/id1484048379';
            if (launchAppState !== ELaunchAppState.SUCCESS && (/mqqbrowser/i.test(ua) || (/micromessenger/i.test(ua) && !(/wxwork/i.test(ua))))) {
                typeof showDefaultGuide === 'function' && showDefaultGuide();
                beaconReport === null || beaconReport === void 0 ? void 0 : beaconReport('web_launchapp_page_mask_null_null_null_explore', { fromSource: from, trigger: 'download_fail' });
            }
        }
    }
    else { // PC 端下载
        location.href = "".concat(window.location.origin, "/download-center.html?from=1002");
    }
};
exports.downloadTencentMeeting = downloadTencentMeeting;
var gotoDownload = function (meetingCode, meetingState, countryCode, showDefaultGuide) {
    // beaconReport('download_app_on_detail_page', {
    //   meeting_code: meetingCode,
    //   meeting_state: meetingState,
    //   is_pmi: getRequest('isPmi') ? 1 : 0, // 是否是PMI会议，1：是
    //   is_doc: getRequest('isDoc') ? 1 : 0, // 是否从文档过来的详情页下载
    // });
    // 用户访问了 “国内域名”
    if ((0, exports.isOverseasByDomainName)() === 'no') {
        // 用户在 国外(ip= 港澳台+海外)
        if (countryCode !== 'cn') {
            // 下载VooV Meeting
            (0, exports.downloadVooVMeeting)();
        }
        else {
            (0, exports.downloadTencentMeeting)(showDefaultGuide);
        }
    }
    else { // 用户访问了 “国外VooV域名”
        // 用户在国内(ip=大陆)
        if (countryCode === 'cn') {
            // 下载腾讯会议
            (0, exports.downloadTencentMeeting)(showDefaultGuide);
        }
        else {
            (0, exports.downloadVooVMeeting)();
        }
    }
};
exports.gotoDownload = gotoDownload;
//# sourceMappingURL=download.js.map